import { PackingTourSteps } from "../../components/TourGuide/tourGuideData";
import { useEffect, useRef, useState } from "react";
import { MdClose, MdPrint } from "react-icons/md";
import { aging, packingEntryAPI, dieMasterAPI, unitConversionAPI } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import ErrorModal from "../../common/CustomModel";
import { HiOutlinePlus } from "react-icons/hi";
import PackingForm from "./PackingForm";
import { RegistryHeader, CalculationFooter, Button } from "../../common/Shared";
import { Info, Upload, Filter as FilterIcon } from "lucide-react";
import { TourGuide } from "../../components/TourGuide/TourGuide";
import Model from "../../common/Model";
import Filter from "../../common/Filter";
import InputField from "../../common/InputField";

const Packing = () => {
  const getDiePdfUrl = (row) => {
    if (!row) return "";
    const pdfUrl = row.die_Pdf || row.diePdf || row.Die_Pdf;
    if (pdfUrl) return pdfUrl;

    const dieId = row.die_Id || row.dieId || row.Die_Id;
    if (dieId) {
      return `https://hline.blob.core.windows.net/hlinefiles/Extrusion/DieMedia/Pdf/${dieId}.pdf`;
    }
    return "";
  };

  const today = new Date().toISOString()?.split("T")[0];
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedPackingData, setSelectedPackingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isPackingData, setisPackingData] = useState([]);
  const [isAgingDoneData, setIsAgingDoneData] = useState([]);
  const [agingFilters, setAgingFilters] = useState({});
  const [packingFilters, setPackingFilters] = useState({});
  const [tempFilters, setTempFilters] = useState({});
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  const [batchOptions, setBatchOptions] = useState([]);
  const [dieOptions, setDieOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [isManualStickerModalOpen, setIsManualStickerModalOpen] = useState(false);
  const [manualStickerForm, setManualStickerForm] = useState({
    bundle_No: "",
    die_Id: "",
    profile_Name: "",
    total_Pcs: "",
    total_Weight: "",
    cut_Length: "",
    unit_Conv_Id: "",
    wt_Pcs: "",
    wt_12_FT: "",
  });

  const updateManualStickerForm = (updates) => {
    setManualStickerForm((prev) => {
      const next = { ...prev, ...updates };

      const selectedUnit = unitOptions.find((u) => String(u.value) === String(next.unit_Conv_Id));

      const getUnit12FtConv = (unitObj) => {
        if (!unitObj) return 12;
        const label = String(unitObj.label || "").toUpperCase();
        const raw = parseFloat(unitObj.raw || 0);
        if (label.includes("INCH")) return 144;
        if (label.includes("MM")) return 3657.6;
        if (label.includes("MTR") || label.includes("METER")) return 3.6576;
        if (label.includes("FT") || label.includes("FEET")) return 12;
        if (raw > 0) {
          if (raw === 304.8) return 3657.6;
          if (raw === 12) return 144;
          if (raw === 1) return 12;
          return raw > 50 ? raw : raw * 12;
        }
        return 12;
      };

      const conv12Ft = getUnit12FtConv(selectedUnit);
      const cutLen = parseFloat(next.cut_Length || 0);
      const pcs = parseFloat(next.total_Pcs || 0);
      const totWt = parseFloat(next.total_Weight || 0);

      // A. If Die No. changed -> populate profile_Name & wt_12_FT if available from die
      if ("die_Id" in updates && updates.die_Id) {
        const selectedDie = dieOptions.find((d) => String(d.value) === String(updates.die_Id));
        if (selectedDie?.profileName) {
          next.profile_Name = selectedDie.profileName;
        }
        if (selectedDie?.wt12Ft) {
          next.wt_12_FT = String(parseFloat(parseFloat(selectedDie.wt12Ft).toFixed(3)));
        }
      }

      // B. If Unit or Cut Length changed -> TOTAL WEIGHT DOES NOT CHANGE!
      // Calculate weight/12 FT based on selected unit & cut length:
      if ("unit_Conv_Id" in updates || "cut_Length" in updates) {
        let perPiece = parseFloat(next.wt_Pcs || 0);
        if ((!perPiece || perPiece === 0) && pcs > 0 && totWt > 0) {
          perPiece = totWt / pcs;
          next.wt_Pcs = String(parseFloat(perPiece.toFixed(3)));
        }
        if (perPiece > 0 && cutLen > 0 && conv12Ft > 0) {
          const wt12FtCalc = (perPiece * conv12Ft) / cutLen;
          next.wt_12_FT = wt12FtCalc > 0 ? String(parseFloat(wt12FtCalc.toFixed(3))) : next.wt_12_FT;
        }
      }

      // C. If Total Weight changed manually -> update wt_Pcs & wt_12_FT (Do not change total_Weight!)
      if ("total_Weight" in updates) {
        if (pcs > 0 && totWt > 0) {
          const perPiece = totWt / pcs;
          next.wt_Pcs = String(parseFloat(perPiece.toFixed(3)));
          if (cutLen > 0 && conv12Ft > 0) {
            const wt12FtCalc = (perPiece * conv12Ft) / cutLen;
            next.wt_12_FT = wt12FtCalc > 0 ? String(parseFloat(wt12FtCalc.toFixed(3))) : next.wt_12_FT;
          }
        }
      }

      // D. If Total PCS changed -> update wt_Pcs & wt_12_FT based on fixed total_Weight
      if ("total_Pcs" in updates) {
        if (pcs > 0 && totWt > 0) {
          const perPiece = totWt / pcs;
          next.wt_Pcs = String(parseFloat(perPiece.toFixed(3)));
          if (cutLen > 0 && conv12Ft > 0) {
            const wt12FtCalc = (perPiece * conv12Ft) / cutLen;
            next.wt_12_FT = wt12FtCalc > 0 ? String(parseFloat(wt12FtCalc.toFixed(3))) : next.wt_12_FT;
          }
        } else if (pcs > 0 && next.wt_Pcs) {
          const perPiece = parseFloat(next.wt_Pcs || 0);
          next.total_Weight = String(parseFloat((pcs * perPiece).toFixed(2)));
        }
      }

      // E. If Weight/Pcs changed manually -> update wt_12_FT & total_Weight if total_Pcs is present
      if ("wt_Pcs" in updates) {
        const perPiece = parseFloat(updates.wt_Pcs || 0);
        if (pcs > 0 && perPiece > 0) {
          next.total_Weight = String(parseFloat((pcs * perPiece).toFixed(2)));
        }
        if (cutLen > 0 && conv12Ft > 0 && perPiece > 0) {
          const wt12FtCalc = (perPiece * conv12Ft) / cutLen;
          next.wt_12_FT = wt12FtCalc > 0 ? String(parseFloat(wt12FtCalc.toFixed(3))) : next.wt_12_FT;
        }
      }

      // F. If Weight/12 FT changed manually -> update wt_Pcs & total_Weight
      if ("wt_12_FT" in updates) {
        const wt12Ft = parseFloat(updates.wt_12_FT || 0);
        if (wt12Ft > 0 && cutLen > 0 && conv12Ft > 0) {
          const perPiece = (wt12Ft * cutLen) / conv12Ft;
          next.wt_Pcs = String(parseFloat(perPiece.toFixed(3)));
          if (pcs > 0) {
            next.total_Weight = String(parseFloat((pcs * perPiece).toFixed(2)));
          }
        }
      }

      return next;
    });
  };

  const handleManualStickerSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!manualStickerForm.bundle_No) {
      notify("Please enter Bundle No.", "warning");
      return;
    }
    setLoading(true);
    try {
      const selectedDie = dieOptions.find((d) => String(d.value) === String(manualStickerForm.die_Id));
      const selectedUnit = unitOptions.find((u) => String(u.value) === String(manualStickerForm.unit_Conv_Id));
      const payload = {
        bundle_No: String(manualStickerForm.bundle_No || ""),
        die_Id: Number(manualStickerForm.die_Id || 0),
        die_No: selectedDie?.label || selectedDie?.dieNumber || "",
        profile_Name: String(manualStickerForm.profile_Name || ""),
        total_Pcs: Number(manualStickerForm.total_Pcs || 0),
        total_Weight: parseFloat(manualStickerForm.total_Weight || 0),
        cut_Length: parseFloat(manualStickerForm.cut_Length || 0),
        wT_Per_Pcs: parseFloat(manualStickerForm.wt_Pcs || 0),
        wT_12_FT: parseFloat(manualStickerForm.wt_12_FT || 0),
        die_Image: selectedDie?.dieImage || "",
        unit_Conv_Name: selectedUnit?.label || "",
      };

      const res = await packingEntryAPI.manualStickerPrint(payload);
      const blob = new Blob([res.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, "_blank");

      notify("Manual sticker printed successfully", "success");
      setIsManualStickerModalOpen(false);
      setManualStickerForm({
        bundle_No: "",
        die_Id: "",
        profile_Name: "",
        total_Pcs: "",
        total_Weight: "",
        cut_Length: "",
        unit_Conv_Id: "",
        wt_Pcs: "",
        wt_12_FT: "",
      });
    } catch (error) {
      notify(error?.response?.data?.message || "Failed to print manual sticker", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleApplyFilters = () => {
    if (isActiveTab === "aging-done") {
      setAgingFilters(tempFilters);
    } else {
      setPackingFilters(tempFilters);
    }
  };

  const handleClearFilters = () => {
    setTempFilters({});
    if (isActiveTab === "aging-done") {
      setAgingFilters({});
    } else {
      setPackingFilters({});
    }
  };

  const openFilterDrawer = () => {
    const currentFilters = isActiveTab === "aging-done" ? agingFilters : packingFilters;
    setTempFilters(currentFilters);
    setIsFilterDrawerOpen(true);
  };

  const getFilterFields = () => {
    if (isActiveTab === "aging-done") {
      return [
        { name: "order_No", label: "Order No", type: "text", placeholder: "Enter Order No..." },
        { name: "batch_Id", label: "Batch No", type: "select", options: batchOptions },
        { name: "dieNumber", label: "Die No", type: "select", options: dieOptions },
        { name: "cut_Length", label: "Cut Length", type: "text", placeholder: "Enter Cut Length..." },
      ];
    } else {
      return [
        { name: "bundle_No", label: "Bundle No", type: "text", placeholder: "Enter Bundle No..." },
        { name: "dieNumber", label: "Die No", type: "select", options: dieOptions },
        { name: "series_Name", label: "Series", type: "select", options: seriesOptions },
        { name: "profile_Name", label: "Profile", type: "text", placeholder: "Enter Profile..." },
      ];
    }
  };

  const renderActiveFilterBadges = () => {
    const currentFilters = isActiveTab === "aging-done" ? agingFilters : packingFilters;
    const activeKeys = Object.keys(currentFilters).filter((k) => currentFilters[k]);

    if (activeKeys.length === 0) return null;

    const getFieldLabel = (key) => {
      const labels = {
        order_No: "Order No",
        batch_Id: "Batch No",
        dieNumber: "Die No",
        cut_Length: "Cut Length",
        bundle_No: "Bundle No",
        series_Name: "Series",
        profile_Name: "Profile",
      };
      return labels[key] || key;
    };

    const getDisplayValue = (key, val) => {
      if (key === "dieNumber") {
        const option = dieOptions.find((d) => String(d.value) === String(val));
        return option ? option.label : val;
      }
      return val;
    };

    const removeFilterKey = (key) => {
      if (isActiveTab === "aging-done") {
        setAgingFilters((prev) => {
          const next = { ...prev };
          delete next[key];
          return next;
        });
      } else {
        setPackingFilters((prev) => {
          const next = { ...prev };
          delete next[key];
          return next;
        });
      }
    };

    return (
      <div className="flex flex-wrap items-center gap-2 py-2 px-1 mb-2 bg-gray-50/50 border-b border-gray-100 rounded-sm">
        <span className="text-[10px] font-bold uppercase tracking-wider text-gray-400">
          Active Filters:
        </span>
        {activeKeys.map((key) => (
          <div
            key={key}
            className="flex items-center gap-1.5 px-2.5 py-1 bg-blue-50 border border-blue-100 text-primary rounded-sm text-[10px] font-medium animate-fadeIn"
          >
            <span>{getFieldLabel(key)}:</span>
            <span className="font-bold">{getDisplayValue(key, currentFilters[key])}</span>
            <button
              onClick={() => removeFilterKey(key)}
              className="text-primary hover:text-red-500 transition-colors ml-1 font-bold text-[11px]"
            >
              ×
            </button>
          </div>
        ))}
        <button
          onClick={handleClearFilters}
          className="text-[10px] font-black uppercase tracking-wider text-red-500 hover:text-red-700 transition-colors ml-auto px-2 py-1"
        >
          Clear All
        </button>
      </div>
    );
  };

  useEffect(() => {
    const loadFilterOptions = async () => {
      try {
        const batchRes = await aging.getAllAgingBatch();
        if (batchRes) {
          const batches = Array.isArray(batchRes) ? batchRes : batchRes.data || [];
          setBatchOptions(
            batches.map((b) => {
              const val = typeof b === "string" ? b : b.batch_Id || b.Batch_Id;
              return { value: val, label: val };
            })
          );
        }

        const dieRes = await dieMasterAPI.getAll();
        if (dieRes) {
          const dies = Array.isArray(dieRes) ? dieRes : dieRes.data || [];
          setDieOptions(
            dies.map((d) => {
              const dieNo = d.dieNumber || d.DieNumber || d.die_No || d.Die_No || d.dieNo || d.DieNo || "";
              const subDieNo = d.subDieNo || d.SubDieNo || d.sub_Die_No || d.Sub_Die_No || d.subDie || d.SubDie || "";
              const label = subDieNo ? `${dieNo} / ${subDieNo}` : dieNo;
              const profileName = d.profileName || d.ProfileName || d.profile_Name || d.Profile_Name || d.profile || d.Profile || "";
              const currentWeightPer12Ft = parseFloat(d.currentWeightPer12Ft || d.CurrentWeightPer12Ft || d.wt_12_FT || d.wT_12_FT || 0);
              const currentWeight = parseFloat(d.currentWeight || d.CurrentWeight || d.weight || 0);
              const dieWt12Ft = currentWeightPer12Ft > 0 ? currentWeightPer12Ft : (currentWeight > 0 ? currentWeight : 0);
              return {
                value: d.id || d.Id,
                label: label,
                dieNumber: dieNo,
                subDieNo: subDieNo,
                profileName: profileName,
                wt12Ft: dieWt12Ft > 0 ? dieWt12Ft : "",
              };
            })
          );
        }

        const unitRes = await unitConversionAPI.getAll();
        if (unitRes) {
          const units = Array.isArray(unitRes) ? unitRes : unitRes.data || [];
          setUnitOptions(
            units.map((u) => ({
              value: u.unit_Conv_Id || u.id,
              label: u.unit_Conv_Name || u.name,
              raw: parseFloat(u.conv_Value || u.conv_value || u.Conv_Value || u.convValue || 1),
            }))
          );
        }
      } catch (err) {
        console.error("Failed to load filter options", err);
      }
    };
    loadFilterOptions();
  }, []);
  const [formData, setFormData] = useState({
    packing_Date: today,
    packingDetails: [{
      bundle_No: "0",
      order_No: "",
      dieNumber: "",
      die_Id: "",
      batch_Id: "",
      casting_No: "",
      cut_Length: "",
      wt_12_FT: "",
      wt_Cut_Length: "",
      pcs: "",
      total_Weight: "",
      series_Name: "",
      remark: "",
      unit_Conv_Id: "",
      final_CutLength_weight: "",
      seq_No: "",
    }]
  });
  const pageSize = 50;
  const [isActiveTab, setIsActiveTab] = useState("aging-done");
  const [selectedAgingNo, setSelectedAgingNo] = useState(null);
  const [adding, setAdding] = useState(false);
  const [selectedBundles, setSelectedBundles] = useState([]);
  const [printModalOpen, setPrintModalOpen] = useState(false);
  const [savedBundles, setSavedBundles] = useState([]);
  const tableScrollRef = useRef(null);
  const isFetchingRef = useRef(false);
  const [packingHasMore, setPackingHasMore] = useState(true);
  const [agingHasMore, setAgingHasMore] = useState(true);
  const [packingPage, setPackingPage] = useState(1);
  const [agingPage, setAgingPage] = useState(1);
  const [isPackingListModalOpen, setIsPackingListModalOpen] = useState(false);
  const [soldOutData, setSoldOutData] = useState([]);
  const [soldOutPage, setSoldOutPage] = useState(1);
  const [soldOutHasMore, setSoldOutHasMore] = useState(true);
  const [scannedBundles, setScannedBundles] = useState([]);
  const [vehicleNo, setVehicleNo] = useState("");
  const [currentBarcode, setCurrentBarcode] = useState("");
  const barcodeInputRef = useRef(null);

  const handleTourComplete = () => {
    localStorage.setItem("aluex_packing_tour_seen", "true");
  };

  const fetchPackingData = async (page = 1, currentFilters = packingFilters) => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllPackingEntry(page, pageSize, currentFilters);
      setisPackingData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setPackingHasMore(false);
      } else {
        setPackingHasMore(true);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching sales order master data", "error");
    }
    setLoading(false);
  };

  const fetchSoldOutData = async (page = 1, currentFilters = packingFilters) => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllSoldOutEntry(page, pageSize, currentFilters);
      setSoldOutData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setSoldOutHasMore(false);
      } else {
        setSoldOutHasMore(true);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching sold out data", "error");
    }
    setLoading(false);
  };

  const submitImport = async (e) => {
    e.preventDefault();
    if (!importFile) {
      notify("Please select a file to import", "warning");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("file", importFile);
    formData.append("userId", userId);

    try {
      await aging.agingDoneImport(formData);
      notify("Imported successfully", "success");
      setIsImportModalOpen(false);
      setImportFile(null);
      if (isActiveTab === "aging-done") fetchAgingDoneData();
    } catch (error) {
      notify(error?.response?.data?.message || "Failed to import file", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (row) => {
    const bundle_No = row?.bundle_No;
    setLoading(true);
    try {
      const res = await packingEntryAPI.getById(bundle_No);
      const doc = res?.data ?? res;
      setSelectedPackingData({
        packing_Date: doc.packing_Date || today,
        totalPcs: doc.totalPcs ?? 0,
        total_Weight: doc.total_Weight ?? 0,
        packingDetails: [doc]
      });
      setIsEditing(true);
      setIsModelOpen(true);
    } catch (err) {
      notify("Failed to fetch packing entry details", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (data) => {
    setIsSaving(true);
    try {
      if (!data.packingDetails || data.packingDetails.length === 0) {
        notify("Please add at least one row.", "warning");
        setIsSaving(false);
        return;
      }

      // Sum of pcs and total weight from row details
      const sumPcs = data.packingDetails.reduce((sum, row) => sum + Number(row.pcs || 0), 0);
      // const sumWeight = data.packingDetails.reduce((sum, row) => sum + parseFloat(row.total_Weight || 0), 0);

      const totalPcsAllowed = Number(data.totalPcs || 0);

      if (totalPcsAllowed > 0 && sumPcs > totalPcsAllowed) {
        notify(`Sum of Pcs (${sumPcs}) cannot exceed Total Pcs (${totalPcsAllowed})`, "error");
        setIsSaving(false);
        return;
      }

      // if (totalWeightAllowed > 0 ) {
      //   notify(`Sum of Total Weight (${sumWeight.toFixed(2)} KG) cannot exceed Total Weight (${totalWeightAllowed.toFixed(2)} KG)`, "error");
      //   setIsSaving(false);
      //   return;
      // }

      const payload = data.packingDetails.map((row) => ({
        bundle_No: String(row.bundle_No || "0"),
        packing_Date: data.packing_Date,
        order_No: Number(row.order_No || 0),
        die_Id: Number(row.die_Id || 0),
        cut_Length: parseFloat(row.cut_Length || 0),
        wT_12_FT: parseFloat(row.wt_12_FT || row.wT_12_FT || 0),
        wT_Cut_Length: parseFloat(row.wt_Cut_Length || row.wT_Cut_Length || 0),
        pcs: Number(row.pcs || 0),
        total_Weight: parseFloat(row.total_Weight || 0),
        series_Name: String(row.series_Name || ""),
        remark: String(row.remark || ""),
        created_By: Number(userId || 0),
        batch_Id: String(row.batch_Id || ""),
        casting_No: String(row.casting_No || ""),
        unit_Conv_Id: Number(row.unit_Conv_Id || 0),
        final_CutLength_weight: parseFloat(row.final_CutLength_weight || 0),
        seq_No: Number(row.seq_No || 0),
      }));

      const response = await packingEntryAPI.saveOrUpdateMultiple(payload);
      notify("Saved successfully", "success");

      const resultsArray = response?.results || (Array.isArray(response) ? response : []);
      const bundleNos = resultsArray.map((r) => r.bundle_No).filter(Boolean);

      setIsActiveTab("packing");
      setPackingPage(1);
      setAgingPage(1);
      fetchPackingData(1);
      fetchAgingDoneData(1);
      setIsModelOpen(false);
      setFormData({
        packing_Date: today,
        totalPcs: 0,
        total_Weight: 0,
        packingDetails: [{
          bundle_No: "0",
          order_No: "",
          dieNumber: "",
          die_Id: "",
          batch_Id: "",
          casting_No: "",
          cut_Length: "",
          wt_12_FT: "",
          wt_Cut_Length: "",
          pcs: "",
          total_Weight: "",
          series_Name: "",
          remark: "",
          unit_Conv_Id: "",
          final_CutLength_weight: "",
          seq_No: "",
        }]
      });
      setIsEditing(false);

      if (bundleNos.length > 0) {
        setSavedBundles(bundleNos);
        setPrintModalOpen(true);
      }
    } catch (error) {
      notify("Failed to submit form", "error");
      setErrorMessage("Submission failed");
      setErrorSubMessage("Please check your input or try again.");
      setErrorModalOpen(true);
    } finally {
      setIsSaving(false);
    }
  };

  const fetchAgingDoneData = async (page = 1, currentFilters = agingFilters) => {
    setLoading(true);
    try {
      const res = await packingEntryAPI.getAllAgingDone(page, pageSize, currentFilters);
      setIsAgingDoneData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setAgingHasMore(false);
      } else {
        setAgingHasMore(true);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  const handleTabChange = (tab) => {
    setIsActiveTab(tab);
    setAgingFilters({});
    setPackingFilters({});
    if (tab === "aging-done") {
      setPackingPage(1);
      setIsAgingDoneData([]);
      setAgingHasMore(true);
      setSoldOutPage(1);
    } else if (tab === "packing") {
      setPackingPage(1);
      setisPackingData([]);
      setPackingHasMore(true);
      setSoldOutPage(1);
    } else if (tab === "sold-out") {
      setSoldOutPage(1);
      setSoldOutData([]);
      setSoldOutHasMore(true);
      setPackingPage(1);
      setAgingPage(1);
    }
  };

  useEffect(() => {
    if (isActiveTab === "aging-done") fetchAgingDoneData(agingPage);
  }, [agingPage, isActiveTab]);

  useEffect(() => {
    if (isActiveTab === "aging-done") {
      if (agingPage === 1) {
        fetchAgingDoneData(1, agingFilters);
      } else {
        setAgingPage(1);
      }
    }
  }, [agingFilters]);

  useEffect(() => {
    if (isActiveTab === "packing") fetchPackingData(packingPage);
  }, [packingPage, isActiveTab]);

  useEffect(() => {
    if (isActiveTab === "packing") {
      if (packingPage === 1) {
        fetchPackingData(1, packingFilters);
      } else {
        setPackingPage(1);
      }
    }
  }, [packingFilters]);

  useEffect(() => {
    if (isActiveTab === "sold-out") fetchSoldOutData(soldOutPage);
  }, [soldOutPage, isActiveTab]);

  useEffect(() => {
    if (isActiveTab === "sold-out") {
      if (soldOutPage === 1) {
        fetchSoldOutData(1, packingFilters);
      } else {
        setSoldOutPage(1);
      }
    }
  }, [packingFilters]);

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 100) {
        isFetchingRef.current = true;

        if (isActiveTab === "aging-done" && agingHasMore) {
          setAgingPage((p) => p + 1);
        }

        if (isActiveTab === "packing" && packingHasMore) {
          setPackingPage((p) => p + 1);
        }

        if (isActiveTab === "sold-out" && soldOutHasMore) {
          setSoldOutPage((p) => p + 1);
        }
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [isActiveTab, loading, packingHasMore, agingHasMore, soldOutHasMore]);

  const columns = [
    {
      key: "select",
      align: "center",
      disableSort: true,
      label: <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Select</span>,
      render: (_v, row) => {
        const id = Number(row.seq_No);
        const isChecked = selectedAgingNo === id;
        return (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={() => setSelectedAgingNo(isChecked ? null : id)}
            className="w-4 h-4 text-primary cursor-pointer accent-primary"
          />
        );
      },
    },
    { key: "order_No", label: "ORDER NO", align: "center" },
    {
      key: "batch_Id",
      label: "BATCH NO",
      align: "center",
      filterType: "select",
      filterOptions: batchOptions,
    },
    {
      key: "dieNumber",
      label: "DIE NO",
      align: "center",
      filterType: "select",
      filterOptions: dieOptions,
      render: (val, row) => {
        const pdfUrl = getDiePdfUrl(row);
        return pdfUrl ? (
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary font-black hover:underline cursor-pointer"
          >
            {val}
          </a>
        ) : (
          <span>{val}</span>
        );
      }
    },
    { key: "cut_Length", label: "CUT LENGTH", align: "center" },
    { key: "quantity", label: "PCS", align: "center", disableFilter: true },
    { key: "pending_Pcs", label: "PENDING PCS", align: "center", disableFilter: true },
    { key: "total_Weight", label: "TOTAL WEIGHT", align: "center", disableFilter: true },
  ];

  const handleAddPacking = async () => {
    if (!selectedAgingNo) {
      notify("Please select one Aging-Done row.", "warning");
      return;
    }
    setAdding(true);
    try {
      const resp = await packingEntryAPI.AddToPacking(selectedAgingNo);
      const x = Array.isArray(resp) ? resp[0] : resp;
      const init = {
        packing_Date: x.packing_Date,
        totalPcs: x?.totalPcs ?? 0,
        total_Weight: x?.total_Weight ?? 0,
        packingDetails: [{
          bundle_No: "0",
          order_No: x?.order_No ?? "",
          die_Id: x?.die_Id ?? null,
          dieNumber: x?.dieNumber ?? "",
          cut_Length: x?.cut_Length ?? "",
          batch_Id: x?.batch_Id ?? "",
          casting_No: x?.casting_No ?? "",
          total_Weight: x?.total_Weight ?? "",
          wt_12_FT: "",
          wt_Cut_Length: x?.cut_Length ?? "",
          pcs: "",
          series_Name: x?.series_Name ?? "",
          remark: "",
          unit_Conv_Id: "",
          final_CutLength_weight: "",
          seq_No: x?.seq_No ?? selectedAgingNo ?? 0,
        }]
      };
      setSelectedPackingData(init);
      setIsModelOpen(true);
      setIsEditing(false);
      setSelectedAgingNo(null);
    } catch (e) {
      notify(
        e?.response?.data?.message || e?.message || "Failed to Add to Packing",
        "error",
      );
    } finally {
      setAdding(false);
    }
  };

  const handlePrint = async () => {
    if (selectedBundles.length === 0) {
      notify("Please select at least one bundle to print", "warning");
      return;
    }

    setLoading(true);
    try {
      const payload = { bundleNos: selectedBundles };
      const res = await packingEntryAPI.packingBundles(payload);

      const blob = new Blob([res.data], { type: "application/pdf" });

      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, "_blank");
    } catch (error) {
      notify("Failed to print selected bundles", "error");
    } finally {
      setLoading(false);
    }
  };

  const currentDataForSeries = isActiveTab === "sold-out" ? soldOutData : isPackingData;
  const seriesOptions = Array.from(
    new Set(currentDataForSeries.map((x) => x.series_Name || x.Series_Name).filter(Boolean))
  ).map((s) => ({ value: s, label: s }));

  const handleDispatchClick = async (dispatchNo) => {
    if (!dispatchNo) return;
    setLoading(true);
    try {
      const res = await packingEntryAPI.generatePackingListByDispatchNo(dispatchNo);
      const blob = new Blob([res.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(blob);
      window.open(pdfUrl, "_blank");
    } catch (error) {
      notify("Failed to generate packing list for this Dispatch No.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-full bg-white font-plus relative">
      {loading && <Loader centered />}

      <RegistryHeader title="Packing Plan View">
        <button
          onClick={() => setIsTourOpen(true)}
          className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
          title="Start Onboarding Tour"
        >
          <Info size={14} className="shrink-0" />
          Guide
        </button>
        <button
          onClick={() => setIsManualStickerModalOpen(true)}
          className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
          title="Manual Sticker Print"
        >
          <MdPrint size={14} className="shrink-0" />
          Manual Sticker Print
        </button>
        <button
          onClick={() => setIsImportModalOpen(true)}
          className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
          title="Import Data"
        >
          <Upload size={14} className="shrink-0" />
          Import
        </button>
        <button
          onClick={openFilterDrawer}
          className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
          title="Open Filter Drawer"
        >
          <FilterIcon size={14} className="shrink-0" />
          Filter
        </button>
        <div className="flex bg-gray-100 p-1 rounded-sm gap-1 shrink-0" data-tour="packing-tabs">
          <button
            onClick={() => handleTabChange("aging-done")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "aging-done"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Aging Done
          </button>
          <button
            onClick={() => handleTabChange("packing")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "packing"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Packing Entry
          </button>
          <button
            onClick={() => handleTabChange("sold-out")}
            className={`px-6 py-2 text-[10px] font-black uppercase tracking-widest transition-all ${isActiveTab === "sold-out"
              ? "bg-primary text-white  #3F80F7]/20"
              : "text-gray-400 hover:text-gray-600 hover:bg-gray-200/50"
              }`}
          >
            Sold Out
          </button>
        </div>
        {isActiveTab === "aging-done" ? (
          <Button
            disabled={adding}
            onClick={handleAddPacking}
            icon={HiOutlinePlus}
            className="whitespace-nowrap"
            loading={adding}
            data-tour="add-packing-btn"
          >
            {adding ? "INITIALIZING..." : `ADD Packing`}
          </Button>
        ) : isActiveTab === "packing" ? (
          <div className="flex gap-2">
            <button
              onClick={() => setIsPackingListModalOpen(true)}
              className="flex items-center gap-2 px-6 py-2 text-[10px] font-black uppercase tracking-widest text-primary hover:bg-primary/5 transition-colors border border-primary bg-white shrink-0"
            >
              Packing List
            </button>
            <Button
              onClick={handlePrint}
              disabled={selectedBundles.length === 0 || loading}
              icon={MdPrint}
              className="whitespace-nowrap"
              loading={adding}
              data-tour="print-sticker-btn"
            >
              {adding ? "INITIALIZING..." : `Print Sticker (${selectedBundles.length})`}
            </Button>
          </div>
        ) : null}
      </RegistryHeader>

      <div className="px-8 pt-0 pb-4 flex-1 overflow-hidden flex flex-col bg-white">
        {renderActiveFilterBadges()}
        <div
          ref={tableScrollRef}
          className="relative flex-1 overflow-auto border border-gray-200 bg-white"
          data-tour="packing-table"
        >
          {isActiveTab === "aging-done" && (
            <div className="min-w-max">
              <Table
                columns={columns}
                data={isAgingDoneData}
                showActions={false}
                onRowClick={(row) => {
                  const id = Number(row.seq_No);
                  setSelectedAgingNo((prev) => (prev === id ? null : id));
                }} tableClassName="text-[13px]"
              />
            </div>
          )}
          {isActiveTab === "packing" && (
            <div className="min-w-max bg-white">
              <Table
                columns={[
                  {
                    key: "select",
                    disableSort: true,
                    disableFilter: true,
                    align: "center",
                    className: "w-12 border-r border-gray-100",
                    label: (
                      <input
                        type="checkbox"
                        checked={
                          isPackingData.length > 0 &&
                          isPackingData.every((row) => selectedBundles.includes(row.bundle_No))
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            const allIds = isPackingData.map((row) => row.bundle_No);
                            setSelectedBundles(allIds);
                          } else {
                            setSelectedBundles([]);
                          }
                        }}
                        className="w-4 h-4 text-primary cursor-pointer"
                      />
                    ),
                    render: (val, row) => (
                      <input
                        type="checkbox"
                        checked={selectedBundles.includes(row.bundle_No)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedBundles((prev) => [...prev, row.bundle_No]);
                          } else {
                            setSelectedBundles((prev) => prev.filter((id) => id !== row.bundle_No));
                          }
                        }}
                        className="w-4 h-4 text-primary cursor-pointer"
                      />
                    )
                  },
                  { key: "bundle_No", label: "BUNDLE NO", align: "center", className: "font-black text-gray-900 border-r border-gray-100" },
                  {
                    key: "dieNumber",
                    label: "DIE NO",
                    align: "left",
                    filterType: "select",
                    filterOptions: dieOptions,
                    className: "font-black text-primary border-r border-gray-100",
                    render: (val, row) => {
                      const pdfUrl = getDiePdfUrl(row);
                      return pdfUrl ? (
                        <a
                          href={pdfUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary font-black hover:underline cursor-pointer"
                        >
                          {val}
                        </a>
                      ) : (
                        <span>{val}</span>
                      );
                    }
                  },
                  {
                    key: "series_Name",
                    label: "SERIES",
                    align: "left",
                    filterType: "select",
                    filterOptions: seriesOptions,
                    className: "border-r border-gray-100 font-black text-gray-800 text-[11px] uppercase tracking-wider"
                  },
                  { key: "profile_Name", label: "PROFILE", align: "left", className: "border-r border-gray-100 text-gray-800 text-[11px] uppercase tracking-wider" },
                  { key: "wt_Cut_Length", label: "FINAL CUT LENGHT", align: "right", disableFilter: true, className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_Cut_Length || row.wT_Cut_Length },
                  { key: "unit_Conv_Name", label: "UNIT", align: "center", disableFilter: true, className: "text-gray-500 border-r border-gray-100 font-black text-[11px] uppercase tracking-widest" },
                  { key: "wt_12_FT", label: "WT/12 FT", align: "right", disableFilter: true, className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_12_FT || row.wT_12_FT },
                  { key: "final_CutLength_Weight", label: "FINAL CUT LENGTH WT", align: "right", disableFilter: true, className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter" },
                  {
                    key: "pcs",
                    label: "PCS",
                    align: "right",
                    disableFilter: true,
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.pcs || row.pcs === 0 ? row.pcs : "-"}
                      </span>
                    )
                  },
                  {
                    key: "total_Weight",
                    label: "TOTAL WT",
                    align: "right",
                    disableFilter: true,
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.total_Weight || row.total_Weight === 0 ? row.total_Weight : "-"}
                      </span>
                    )
                  },
                  {
                    key: "actions",
                    label: "ACTIONS",
                    align: "center",
                    disableFilter: true,
                    render: (val, row) => (
                      <button
                        onClick={() => handleEdit(row)}
                        className="px-2.5 py-1 border border-gray-200 text-blue-600 hover:bg-blue-50 transition-all text-[10px] font-black uppercase tracking-wider rounded-none"
                      >
                        Edit
                      </button>
                    )
                  }
                ]}
                data={isPackingData}
                showActions={false}
                tableClassName="text-[13px] border-none"
              />
            </div>
          )}
          {isActiveTab === "sold-out" && (
            <div className="min-w-max bg-white">
              <Table
                columns={[
                  {
                    key: "dispatch_No",
                    label: "DISPATCH NO",
                    align: "center",
                    className: "font-black text-gray-900 border-r border-gray-100",
                    render: (val) => {
                      return val ? (
                        <span
                          onClick={() => handleDispatchClick(val)}
                          className="text-primary hover:underline cursor-pointer"
                        >
                          {val}
                        </span>
                      ) : (
                        <span>-</span>
                      );
                    }
                  },
                  { key: "dispatch_Date", label: "DISPATCH DATE", align: "center", },
                  { key: "bundle_No", label: "BUNDLE NO", align: "center", className: "font-black text-gray-900 border-r border-gray-100" },
                  {
                    key: "dieNumber",
                    label: "DIE NO",
                    align: "left",
                    filterType: "select",
                    filterOptions: dieOptions,
                    className: "font-black text-primary border-r border-gray-100",
                    render: (val, row) => {
                      const pdfUrl = getDiePdfUrl(row);
                      return pdfUrl ? (
                        <a
                          href={pdfUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary font-black hover:underline cursor-pointer"
                        >
                          {val}
                        </a>
                      ) : (
                        <span>{val}</span>
                      );
                    }
                  },
                  {
                    key: "series_Name",
                    label: "SERIES",
                    align: "left",
                    filterType: "select",
                    filterOptions: seriesOptions,
                    className: "border-r border-gray-100 font-black text-gray-800 text-[11px] uppercase tracking-wider"
                  },
                  { key: "profile_Name", label: "PROFILE", align: "left", className: "border-r border-gray-100 text-gray-800 text-[11px] uppercase tracking-wider" },
                  { key: "wt_Cut_Length", label: "FINAL CUT LENGHT", align: "right", disableFilter: true, className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_Cut_Length || row.wT_Cut_Length },
                  { key: "unit_Conv_Name", label: "UNIT", align: "center", disableFilter: true, className: "text-gray-500 border-r border-gray-100 font-black text-[11px] uppercase tracking-widest" },
                  { key: "wt_12_FT", label: "WT/12 FT", align: "right", disableFilter: true, className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter", render: (val, row) => row.wt_12_FT || row.wT_12_FT },
                  { key: "final_CutLength_Weight", label: "FINAL CUT LENGTH WT", align: "right", disableFilter: true, className: "text-gray-600 border-r border-gray-100 font-mono tracking-tighter" },
                  {
                    key: "pcs",
                    label: "PCS",
                    align: "right",
                    disableFilter: true,
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.pcs || row.pcs === 0 ? row.pcs : "-"}
                      </span>
                    )
                  },
                  {
                    key: "total_Weight",
                    label: "TOTAL WT",
                    align: "right",
                    disableFilter: true,
                    className: "border-r border-gray-100 w-28",
                    render: (val, row) => (
                      <span className="block px-2 py-1 font-medium text-right">
                        {row.total_Weight || row.total_Weight === 0 ? row.total_Weight : "-"}
                      </span>
                    )
                  }
                ]}
                data={soldOutData}
                showActions={false}
                tableClassName="text-[13px] border-none"
              />
            </div>
          )}
        </div>
      </div>

      {isModelOpen && formData && (
        <PackingForm
          initialData={selectedPackingData}
          onSave={handleSave}
          onCancel={() => setIsModelOpen(false)}
          isEditing={isEditing}
          formData={formData}
          setFormData={setFormData}
          isSaving={isSaving}
        />
      )}

      <Model
        isOpen={isImportModalOpen}
        onClose={() => {
          setIsImportModalOpen(false);
          setImportFile(null);
        }}
        name="Import Aging Done"
        widthClass="max-w-md"
      >
        <form onSubmit={submitImport} className="flex flex-col p-6 gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-[11px] font-bold text-gray-600 uppercase tracking-wider flex items-center gap-1.5">
              Select File <span className="text-red-500">*</span>
            </label>
            <input
              type="file"
              accept=".xlsx,.xls,.csv"
              required
              onChange={(e) => setImportFile(e.target.files?.[0] || null)}
              className="w-full py-2 px-3 border border-gray-200 text-[13px] bg-white focus:outline-none focus:border-primary transition-colors"
            />
          </div>

          <div className="flex justify-end gap-2 mt-4 pt-4 border-t border-slate-100">
            <button
              type="button"
              onClick={() => {
                setIsImportModalOpen(false);
                setImportFile(null);
              }}
              className="px-4 py-2 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors disabled:opacity-50"
            >
              {loading ? "Importing..." : "Submit"}
            </button>
          </div>
        </form>
      </Model>
      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}

      <Model
        isOpen={isPackingListModalOpen}
        onClose={() => {
          setIsPackingListModalOpen(false);
          setScannedBundles([]);
          setVehicleNo("");
          setCurrentBarcode("");
        }}
        name="Generate Packing List"
        widthClass="max-w-2xl"
        closeOnOutsideClick={false}
      >
        <div className="flex flex-col p-6 gap-4">
          <div className="flex gap-4">
            <div className="flex-1 flex flex-col gap-1">
              <label className="text-[11px] font-bold text-gray-600 uppercase tracking-wider flex items-center gap-1.5">
                Scan Barcode
              </label>
              <input
                ref={barcodeInputRef}
                type="text"
                value={currentBarcode}
                onChange={(e) => setCurrentBarcode(e.target.value)}
                onKeyDown={async (e) => {
                  if (e.key === 'Enter' && currentBarcode.trim()) {
                    e.preventDefault();
                    const scannedCode = currentBarcode.trim();

                    if (scannedBundles.includes(scannedCode)) {
                      notify("Bundle already scanned", "warning");
                      setCurrentBarcode("");
                      return;
                    }

                    try {
                      const res = await packingEntryAPI.validateBundleNo(scannedCode);
                      if (res === "Valid" || res?.message === "Valid" || res?.status === "Valid") {
                        setScannedBundles(prev => [...prev, scannedCode]);
                      } else {
                        notify(res?.message || res || "Invalid Bundle No", "warning");
                      }
                    } catch (error) {
                      notify(error?.response?.data?.message || error?.message || "Failed to validate barcode", "warning");
                    }
                    setCurrentBarcode("");
                  }
                }}
                placeholder="Scan or enter bundle no and press Enter"
                className="w-full py-2 px-3 border border-gray-200 text-[13px] bg-white focus:outline-none focus:border-primary transition-colors"
                autoFocus
              />
            </div>
            <div className="flex-1 flex flex-col gap-1">
              <label className="text-[11px] font-bold text-gray-600 uppercase tracking-wider flex items-center gap-1.5">
                Vehicle No <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={vehicleNo}
                onChange={(e) => setVehicleNo(e.target.value)}
                placeholder="Enter Vehicle No"
                className="w-full py-2 px-3 border border-gray-200 text-[13px] bg-white focus:outline-none focus:border-primary transition-colors uppercase"
              />
            </div>
          </div>

          <div className="mt-2 border border-gray-200 rounded-sm overflow-hidden flex flex-col" style={{ minHeight: '200px' }}>
            <div className="bg-gray-50 px-4 py-2 border-b border-gray-200 text-[11px] font-black text-gray-600 uppercase tracking-wider flex justify-between">
              <span>Scanned Bundles ({scannedBundles.length})</span>
              {scannedBundles.length > 0 && (
                <button onClick={() => setScannedBundles([])} className="text-red-500 hover:text-red-700 font-bold text-[10px]">Clear All</button>
              )}
            </div>
            <div className="flex-1 overflow-y-auto p-4 bg-slate-50 flex flex-wrap gap-2 items-start content-start">
              {scannedBundles.map((b, idx) => (
                <div key={idx} className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-200 text-primary font-mono text-[13px] font-black tracking-tight group">
                  {b}
                  <MdClose
                    className="cursor-pointer text-gray-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity"
                    onClick={() => setScannedBundles(prev => prev.filter(item => item !== b))}
                  />
                </div>
              ))}
              {scannedBundles.length === 0 && (
                <div className="text-gray-400 text-sm w-full text-center py-8">No bundles scanned yet</div>
              )}
            </div>
          </div>

          <div className="flex justify-end gap-2 mt-4 pt-4 border-t border-slate-100">
            <button
              type="button"
              onClick={() => {
                setIsPackingListModalOpen(false);
                setScannedBundles([]);
                setVehicleNo("");
                setCurrentBarcode("");
              }}
              className="px-4 py-2 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={loading || scannedBundles.length === 0 || !vehicleNo.trim()}
              onClick={async () => {
                setLoading(true);
                try {
                  const payload = {
                    bundleNos: scannedBundles,
                    vehicleNo: vehicleNo.trim()
                  };
                  const res = await packingEntryAPI.generatePackingList(payload);

                  const blob = new Blob([res.data], { type: "application/pdf" });
                  const pdfUrl = URL.createObjectURL(blob);
                  window.open(pdfUrl, "_blank");

                  notify("Packing list generated successfully", "success");
                  setIsPackingListModalOpen(false);
                  setScannedBundles([]);
                  setVehicleNo("");
                  setCurrentBarcode("");
                  fetchPackingData()
                } catch (error) {
                  notify(error?.response?.data?.message || "Failed to generate packing list", "error");
                } finally {
                  setLoading(false);
                }
              }}
              className="px-6 py-2 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors disabled:opacity-50 flex gap-2 items-center"
            >
              {loading ? "Generating..." : "Save & Generate"}
            </button>
          </div>
        </div>
      </Model>

      <Model
        isOpen={printModalOpen}
        onClose={() => setPrintModalOpen(false)}
        name="Print Bundle"
        widthClass="max-w-md"
      >
        <div className="flex flex-col p-6 gap-5">
          <div className="flex flex-col gap-2.5 text-center">
            <div className="w-12 h-12 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center mx-auto mb-2">
              <MdPrint size={24} />
            </div>
            <h3 className="text-sm font-black text-gray-800 uppercase tracking-wider">
              Do you want to print the stickers?
            </h3>
            <div className="flex flex-wrap gap-1.5 justify-center max-h-36 overflow-y-auto bg-slate-50 p-3 border border-slate-100/80 rounded-none">
              {savedBundles.map((b, idx) => (
                <span
                  key={idx}
                  className="px-2.5 py-1 bg-white border border-gray-200 text-primary font-mono text-[11px] font-black tracking-tight"
                >
                  {b}
                </span>
              ))}
            </div>
          </div>

          <div className="flex justify-center gap-3 mt-4 pt-4 border-t border-slate-100">
            <button
              onClick={() => setPrintModalOpen(false)}
              className="px-5 py-2.5 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors rounded-none w-28"
            >
              No
            </button>
            <button
              onClick={async () => {
                setPrintModalOpen(false);
                setLoading(true);
                try {
                  const payload = { bundleNos: savedBundles };
                  const res = await packingEntryAPI.packingBundles(payload);
                  const blob = new Blob([res.data], { type: "application/pdf" });
                  const pdfUrl = URL.createObjectURL(blob);
                  window.open(pdfUrl, "_blank");
                } catch (error) {
                  notify("Failed to print selected bundles", "error");
                } finally {
                  setLoading(false);
                }
              }}
              className="px-5 py-2.5 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors rounded-none w-28 shadow-sm"
            >
              Yes
            </button>
          </div>
        </div>
      </Model>


      <div data-tour="packing-footer">
        <CalculationFooter
          items={[
            isActiveTab === 'packing' && {
              label: "Selected Rows",
              value: isActiveTab === 'packing' ? selectedBundles.length : 0,
              suffix: "Rows",
              color: "text-green-500"
            },
            (isActiveTab === 'packing' || isActiveTab === "aging-done") && {
              label: "Selected Units",
              value: isActiveTab === 'packing'
                ? isPackingData
                  .filter((row) => selectedBundles.includes(row.bundle_No))
                  .reduce((sum, row) => sum + (Number(row.pcs) || 0), 0)
                  .toLocaleString()
                : isAgingDoneData
                  .filter((row) => Number(row.seq_No) === selectedAgingNo)
                  .reduce((sum, row) => sum + (Number(row.quantity) || 0), 0)
                  .toLocaleString(),
              suffix: "PCS",
              color: "text-primary"
            }, (isActiveTab === 'packing' || isActiveTab === "aging-done") && {
              label: "Selected Weight",
              value: isActiveTab === 'packing'
                ? isPackingData
                  .filter((row) => selectedBundles.includes(row.bundle_No))
                  .reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0)
                  .toFixed(3)
                : isAgingDoneData
                  .filter((row) => Number(row.seq_No) === selectedAgingNo)
                  .reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0)
                  .toFixed(3),
              suffix: "KG",
              color: "text-primary"
            }, {
              label: "Total Units",
              value: isActiveTab === 'packing'
                ? isPackingData.reduce((sum, row) => sum + (Number(row.pcs) || 0), 0).toLocaleString()
                : isActiveTab === 'sold-out'
                  ? soldOutData.reduce((sum, row) => sum + (Number(row.pcs) || 0), 0).toLocaleString()
                  : isAgingDoneData.reduce((sum, row) => sum + (Number(row.quantity) || 0), 0).toLocaleString(),
              suffix: "PCS"
            },
            {
              label: "Total Weight",
              value: isActiveTab === 'packing'
                ? isPackingData.reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0).toFixed(3)
                : isActiveTab === 'sold-out'
                  ? soldOutData.reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0).toFixed(3)
                  : isAgingDoneData.reduce((sum, row) => sum + (Number(row.total_Weight) || 0), 0).toFixed(3),
              suffix: "KG",
              color: "text-black"
            },


          ].filter(Boolean)}
        />
      </div>

      <Model
        isOpen={isManualStickerModalOpen}
        onClose={() => {
          setIsManualStickerModalOpen(false);
        }}
        name="Manual Sticker Print"
        widthClass="max-w-2xl"
      >
        <form onSubmit={handleManualStickerSubmit} className="flex flex-col p-6 gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <InputField
              label="Bundle No."
              type="text"
              required
              value={manualStickerForm.bundle_No}
              onChange={(val) =>
                setManualStickerForm((prev) => ({ ...prev, bundle_No: val }))
              }
              placeholder="Enter Bundle No."
            />
            <InputField
              label="Die No."
              type="select"
              options={dieOptions}
              value={manualStickerForm.die_Id}
              onChange={(val) => updateManualStickerForm({ die_Id: val })}
              placeholder="Select Die No."
            />
            <InputField
              label="Profile Name"
              type="text"
              value={manualStickerForm.profile_Name}
              onChange={(val) => updateManualStickerForm({ profile_Name: val })}
              placeholder="Enter Profile Name"
            />
            <InputField
              label="Total PCS"
              type="number"
              value={manualStickerForm.total_Pcs}
              onChange={(val) => updateManualStickerForm({ total_Pcs: val })}
              placeholder="Enter Total PCS"
            />
            <InputField
              label="Total Weight"
              type="number"
              step="any"
              value={manualStickerForm.total_Weight}
              onChange={(val) => updateManualStickerForm({ total_Weight: val })}
              placeholder="Enter Total Weight"
            />
            <div className="flex gap-2">
              <div className="flex-1">
                <InputField
                  label="Cut Length"
                  type="number"
                  step="any"
                  value={manualStickerForm.cut_Length}
                  onChange={(val) => updateManualStickerForm({ cut_Length: val })}
                  placeholder="Enter Cut Length"
                />
              </div>
              <div className="w-1/2">
                <InputField
                  label="Unit"
                  type="select"
                  options={unitOptions}
                  value={manualStickerForm.unit_Conv_Id}
                  onChange={(val) => updateManualStickerForm({ unit_Conv_Id: val })}
                  placeholder="Select Unit"
                />
              </div>
            </div>
            <InputField
              label="Weight/Pcs"
              type="number"
              step="any"
              value={manualStickerForm.wt_Pcs}
              onChange={(val) => updateManualStickerForm({ wt_Pcs: val })}
              placeholder="Enter Weight/Pcs"
            />
            <InputField
              label="Weight/12 FT"
              type="number"
              step="any"
              value={manualStickerForm.wt_12_FT}
              onChange={(val) => updateManualStickerForm({ wt_12_FT: val })}
              placeholder="Enter Weight/12 FT"
            />
          </div>

          <div className="flex justify-end gap-2 mt-4 pt-4 border-t border-slate-100">
            <button
              type="button"
              onClick={() => {
                setIsManualStickerModalOpen(false);
              }}
              className="px-4 py-2 border border-gray-200 text-[10px] font-black uppercase tracking-widest text-gray-500 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-6 py-2 bg-primary text-white text-[10px] font-black uppercase tracking-widest hover:bg-primary/95 transition-colors disabled:opacity-50 flex items-center gap-2"
            >
              <MdPrint size={14} />
              {loading ? "Generating..." : "Print Sticker"}
            </button>
          </div>
        </form>
      </Model>

      <TourGuide
        isOpen={isTourOpen}
        steps={PackingTourSteps}
        title="Packing Guide"
        model="Packing Module"
        onClose={() => {
          setIsTourOpen(false);
          handleTourComplete();
        }}
      />

      <Filter
        isOpen={isFilterDrawerOpen}
        onClose={() => setIsFilterDrawerOpen(false)}
        filterFields={getFilterFields()}
        filters={tempFilters}
        setFilters={setTempFilters}
        applyFilters={handleApplyFilters}
        clearFilters={handleClearFilters}
      />
    </div>

  );
};

export default Packing;
